import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAnnouncements } from '../context/AnnouncementContext';
import logoWhite from '../media/logo_white.png';
import acceuilImage from '../media/acceuil.jpg';

const Hero: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const { bannerHeight } = useAnnouncements();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative min-h-screen flex items-center" style={{ paddingTop: `${80 + bannerHeight}px` }}>
      {/* Background image with blue gradient overlay */}
      <div className="absolute inset-0 bg-accent animate-fade-in">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${acceuilImage})`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-accent to-black opacity-80"></div>
      </div>
      
      {/* Contenu */}
      <div className="relative section-container flex flex-col items-center text-center z-10">
        <img 
          src={logoWhite} 
          alt="Logo Dr. Banelhaq" 
          className="h-28 mb-8 animate-fade-in-scale" 
        />
        <h1 className="text-4xl md:text-5xl lg:text-6xl text-white font-bold mb-6 leading-tight animate-fade-in-up animation-delay-200">
          Votre sourire, <br className="hidden md:block" />
          <span className="text-blue-light">notre priorité</span>
        </h1>
        <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-2xl font-light animate-fade-in-up animation-delay-400">
          Dr. Banelhaq Ayoub vous accueille dans son cabinet dentaire à Tanger pour des soins de qualité dans une ambiance chaleureuse et professionnelle.
        </p>
        
        <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-6 animate-fade-in-up animation-delay-600">
          <Link to="/rendez-vous" className="btn-primary text-lg px-8 py-4">
            Réserver un rendez-vous
          </Link>
          <a 
            href="https://wa.me/212684707407" 
            target="_blank"
            rel="noopener noreferrer"
            className="btn-whatsapp text-lg px-8 py-4"
          >
            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            Contact WhatsApp
          </a>
        </div>
        
        {/* Google Review Badge - mobile only, below CTAs when not scrolled; joins socials when scrolled */}
        {!scrolled && (
          <div className="block md:hidden mt-6 w-full flex justify-center">
            <a
              href="https://www.google.com/maps/place/Cabinet+dentaire+Dr.+Banelhaq+Ayoub/@35.7472832,-5.84238,17z/data=!3m1!4b1!4m6!3m5!1s0xd0b872651725e0b:0xaee4928dbd319fcd!8m2!3d35.7472789!4d-5.8398051!16s%2Fg%2F11xf3rfs_z?entry=ttu&g_ep=EgoyMDI1MDYyOS4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Noter sur Google"
              className="group flex items-center px-5 py-3 rounded-full shadow-2xl bg-white border-2 border-[#4285F4] hover:bg-[#4285F4] transition-all duration-200 animate-fade-in-up"
              style={{ boxShadow: '0 8px 32px 0 rgba(66,133,244,0.18)' }}
              title="Laissez-nous un avis sur Google!"
            >
              <svg className="w-6 h-6 mr-2" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_17_40)">
                  <path d="M47.617 24.5455C47.617 22.7336 47.4645 21.0682 47.2327 19.3636H24.48V28.9091H37.6173C37.3645 30.5455 36.2736 32.9091 33.9091 34.5455L33.8755 34.7645L41.3455 40.5455L41.8727 40.6C46.0182 36.8364 47.617 31.2727 47.617 24.5455Z" fill="#4285F4"/>
                  <path d="M24.48 47.2727C30.6182 47.2727 35.7091 45.2727 39.8727 40.6L33.9091 34.5455C31.8364 36.0182 29.0182 37.0909 24.48 37.0909C18.491 37.0909 13.2736 33.3091 11.491 27.9636L11.2727 27.9818L3.52727 33.9818L3.41818 34.1818C7.56364 41.3636 15.4182 47.2727 24.48 47.2727Z" fill="#34A853"/>
                  <path d="M11.491 27.9636C11.0182 26.5091 10.7455 24.9636 10.7455 23.3636C10.7455 21.7636 11.0182 20.2182 11.4545 18.7636L11.4445 18.5327L3.63636 12.4182L3.41818 12.5455C1.83636 15.5636 0.890909 18.8909 0.890909 23.3636C0.890909 27.8364 1.83636 31.1636 3.41818 34.1818L11.491 27.9636Z" fill="#FBBC05"/>
                  <path d="M24.48 9.63636C29.0182 9.63636 32.0182 11.5455 33.7091 13.0909L40.0182 7.01818C35.6909 2.98182 30.6182 0.909088 24.48 0.909088C15.4182 0.909088 7.56364 6.81818 3.41818 12.5455L11.4545 18.7636C13.2736 13.4182 18.491 9.63636 24.48 9.63636Z" fill="#EA4335"/>
                </g>
                <defs>
                  <clipPath id="clip0_17_40">
                    <rect width="46.8" height="46.8" fill="white" transform="translate(0.890909 0.909088)"/>
                  </clipPath>
                </defs>
              </svg>
              <svg className="w-5 h-5 mr-2 text-yellow-400 animate-bounce" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.385 2.46a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.385-2.46a1 1 0 00-1.175 0l-3.385 2.46c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 1 0 00-.364-1.118l-3.385-2.46c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.967z"/>
              </svg>
              <span className="font-semibold text-[#4285F4] group-hover:text-white transition-colors duration-200">Noter sur Google</span>
              <span className="absolute opacity-0 group-hover:opacity-100 bg-black text-white text-xs rounded py-1 px-3 pointer-events-none transition-opacity duration-200 -top-10 right-0 whitespace-nowrap z-50 shadow-lg">
                Laissez-nous un avis sur Google!
              </span>
            </a>
          </div>
        )}
        
        {/* Badge services */}
        <div className="absolute -bottom-16 left-0 right-0 mx-auto flex justify-center animate-fade-in-up animation-delay-800">
          <div className="bg-white py-5 px-8 rounded-xl shadow-elegant max-w-3xl mx-auto">
            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-center">
              <div className="w-24 animate-fade-in-up animation-delay-1000">
                <p className="text-primary font-semibold">Soins</p>
              </div>
              <div className="w-24 animate-fade-in-up animation-delay-1100">
                <p className="text-primary font-semibold">Chirurgie</p>
              </div>
              <div className="w-24 animate-fade-in-up animation-delay-1200">
                <p className="text-primary font-semibold">Esthétique</p>
              </div>
              <div className="w-24 animate-fade-in-up animation-delay-1300">
                <p className="text-primary font-semibold">Implants</p>
              </div>
              <div className="w-24 animate-fade-in-up animation-delay-1400">
                <p className="text-primary font-semibold">Orthodontie</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Google Review Badge - desktop only, floating bottom-left of Hero when not scrolled */}
      {!scrolled && (
        <div className="hidden md:block">
          <a
            href="https://www.google.com/maps/place/Cabinet+dentaire+Dr.+Banelhaq+Ayoub/@35.7472832,-5.84238,17z/data=!3m1!4b1!4m6!3m5!1s0xd0b872651725e0b:0xaee4928dbd319fcd!8m2!3d35.7472789!4d-5.8398051!16s%2Fg%2F11xf3rfs_z?entry=ttu&g_ep=EgoyMDI1MDYyOS4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Noter sur Google"
            className="group absolute z-40 left-8 bottom-8 flex items-center px-6 py-3 rounded-full shadow-2xl bg-white border-2 border-[#4285F4] hover:bg-[#4285F4] transition-all duration-300 animate-fade-in-up"
            style={{ boxShadow: '0 8px 32px 0 rgba(66,133,244,0.18)' }}
            title="Laissez-nous un avis sur Google!"
            tabIndex={0}
          >
            <svg className="w-7 h-7 mr-3" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_17_40)">
                <path d="M47.617 24.5455C47.617 22.7336 47.4645 21.0682 47.2327 19.3636H24.48V28.9091H37.6173C37.3645 30.5455 36.2736 32.9091 33.9091 34.5455L33.8755 34.7645L41.3455 40.5455L41.8727 40.6C46.0182 36.8364 47.617 31.2727 47.617 24.5455Z" fill="#4285F4"/>
                <path d="M24.48 47.2727C30.6182 47.2727 35.7091 45.2727 39.8727 40.6L33.9091 34.5455C31.8364 36.0182 29.0182 37.0909 24.48 37.0909C18.491 37.0909 13.2736 33.3091 11.491 27.9636L11.2727 27.9818L3.52727 33.9818L3.41818 34.1818C7.56364 41.3636 15.4182 47.2727 24.48 47.2727Z" fill="#34A853"/>
                <path d="M11.491 27.9636C11.0182 26.5091 10.7455 24.9636 10.7455 23.3636C10.7455 21.7636 11.0182 20.2182 11.4545 18.7636L11.4445 18.5327L3.63636 12.4182L3.41818 12.5455C1.83636 15.5636 0.890909 18.8909 0.890909 23.3636C0.890909 27.8364 1.83636 31.1636 3.41818 34.1818L11.491 27.9636Z" fill="#FBBC05"/>
                <path d="M24.48 9.63636C29.0182 9.63636 32.0182 11.5455 33.7091 13.0909L40.0182 7.01818C35.6909 2.98182 30.6182 0.909088 24.48 0.909088C15.4182 0.909088 7.56364 6.81818 3.41818 12.5455L11.4545 18.7636C13.2736 13.4182 18.491 9.63636 24.48 9.63636Z" fill="#EA4335"/>
              </g>
              <defs>
                <clipPath id="clip0_17_40">
                  <rect width="46.8" height="46.8" fill="white" transform="translate(0.890909 0.909088)"/>
                </clipPath>
              </defs>
            </svg>
            <svg className="w-6 h-6 mr-2 text-yellow-400 animate-bounce" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.385 2.46a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.385-2.46a1 1 0 00-1.175 0l-3.385 2.46c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 1 0 00-.364-1.118l-3.385-2.46c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.967z"/>
            </svg>
            <span className="font-semibold text-[#4285F4] group-hover:text-white transition-colors duration-200 text-lg">Noter sur Google</span>
            <span className="absolute opacity-0 group-hover:opacity-100 bg-black text-white text-xs rounded py-1 px-3 pointer-events-none transition-opacity duration-200 -top-10 left-1/2 -translate-x-1/2 whitespace-nowrap z-50 shadow-lg">
              Laissez-nous un avis sur Google!
            </span>
          </a>
        </div>
      )}
    </div>
  );
};

export default Hero; 